import React, { useEffect, useState } from 'react';
import { Alert } from '@mui/material';
import { apiFetch } from '../utils/apiFetch';
import { getApiUrl } from '../utils/api';
import { getBillingNotice } from '../utils/billingNotice';

export default function BillingNoticeBanner({ enabled }) {
  const [notice, setNotice] = useState(null);

  useEffect(() => {
    let active = true;
    if (!enabled) {
      setNotice(null);
      return undefined;
    }
    apiFetch(`${getApiUrl()}/api/system/entitlements`)
      .then((response) => response.ok ? response.json() : null)
      .then((data) => {
        if (active) setNotice(getBillingNotice(data?.entitlements || data));
      })
      .catch(() => {});
    return () => { active = false; };
  }, [enabled]);

  if (!notice) return null;
  return (
    <Alert severity={notice.severity} variant="filled" sx={{ borderRadius: 0, justifyContent: 'center' }}>
      {notice.message}
    </Alert>
  );
}
